import React, { useState, useEffect } from "react";
import { LuSearch } from "react-icons/lu";

function SearchBar({ isOpen, openSearch }) {
  const [inputMode, setInputMode] = useState("mouse");

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Tab") setInputMode("keyboard");
    };
    const onMouse = () => setInputMode("mouse");
    const onTouch = () => setInputMode("touch");
    window.addEventListener("keydown", onKey);
    window.addEventListener("mousedown", onMouse);
    window.addEventListener("touchstart", onTouch, { passive: true });
    return () => {
      window.removeEventListener("keydown", onKey);
      window.removeEventListener("mousedown", onMouse);
      window.removeEventListener("touchstart", onTouch);
    };
  }, []);

  if (isOpen) return null;

  return (
    <div className="nav-search-slot">
      <button
        type="button"
        className="header-search-trigger nav-search-trigger"
        aria-label="Open site search"
        aria-haspopup="dialog"
        onClick={() => {
          openSearch();

          // ⭐ SEND MESSAGE TO DUDA TO EXPAND IFRAME ⭐
          try {
            window.parent.postMessage({ type: "TEX_SEARCH_EXPANDED" }, "*");
          } catch (e) {
            console.warn("PostMessage failed", e);
          }
        }}
        onFocus={(e) => {
          if (inputMode !== "keyboard") e.target.blur();
        }}
      >
        <LuSearch size={18} className="trigger-icon" />
        <span className="trigger-placeholder">Search…</span>
      </button>
    </div>
  );
}

export default SearchBar;
